export enum CopilotLegalTermsStatus {
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  UNREVIEWED = 'UNREVIEWED',
}

export interface CopilotLegalTerms {
  accountKey: string
  legalTermsStatus: CopilotLegalTermsStatus
  reviewer?: string
  lastModifiedTime?: Date
}
